/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

import {
  autoFormateDate,
  fromQtrToDT,
  toQtrToDT,
  tabHighLigther,
  validateDateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import {
  validateDate,
  compareDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';

import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
  checkQuarterValidation,
  compareQtrs,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  dispatchQtrRange,
  dispatchErrorMsgPreInvoice,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  getSelectedOption,
  getSelectedReportOption,
  dispatchDateRange,
  getPreInvoiceSummary,
  getPreInvoiceDetail,
  dispatchPreInvoiceDetail,
  dispatchPreInvoiceSummary,
  dispatchDisplayObjInvoice,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  VALIDATE_QUARTER_VALUE,
  START_QUATER_REQ,
  QTR_VALIDATION_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';

import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const PreInvoice = (props) => {
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const requestCurrentDisData = useSelector(
    (state) => state?.sharedState?.PreInvoiceReducer?.performResolutionObj
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.PreInvoiceReducer?.planType
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.PreInvoiceReducer?.rebateProgram
  );
  const getRebateProgramName = useSelector(
    (state) => state?.sharedState?.PreInvoiceReducer?.rebateProgramName
  );

  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.PreInvoiceReducer?.errorMsgPreInvoice
  );
  const getPreInvoiceSum = useSelector(
    (state) => state?.sharedState?.PreInvoiceReducer?.preInvoiceSum
  );
  const getPreInvoiceDetailList = useSelector(
    (state) => state?.sharedState?.PreInvoiceReducer?.preInvoiceDet
  );
  const {
    begin: beginDateValue,
    end: endDateValue,
    selectedOption: selectedOptionValue,
    selectedReportOption: selectedReportValue,
    quarterFrom: startQtrValue,
  } = useSelector((state) => state?.sharedState?.PreInvoiceReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [radioList, setRadioList] = useState([]);

  const gridRef = useRef();

  const [rebateProgramList, setRebateProgramList] = useState([]);

  const dispatch = useDispatch();

  const [startQtr, setStartQtr] = useState(startQtrValue);
  const [begin, setBegin] = useState(beginDateValue);
  const [end, setEnd] = useState(endDateValue);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [selectedOption, setSelectedOption] = useState(selectedOptionValue);
  const [selectedReport, setSelectedReport] = useState(selectedReportValue);

  // date validator
  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  // local variable

  const [state, setState] = useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd:
            getRebateProgramName || userDefaults?.rebateProgramCd
              ? userDefaults?.rebateProgramCd
              : '-1',
        }
  );

  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setPerformScrData({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  //Resetting error message on input field change
  React.useEffect(()=> {
    dispatch(dispatchErrorMsgPreInvoice([]));
  }, [state.planTypeCd, state.rebateProgramCd, selectedReport, selectedOption])

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd' && item.field != 'noData');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPreInvoice(unique));
  };

  
  const normalizeQuarterPattern = (val = '') => {
  let v = (val || '').trim().toUpperCase().replace(/\s+/g, '');
 
  let m = v.match(/^(20\d{2})Q([1-4])$/);
  if (m) return `${m[2]}Q${m[1]}`;
 
  m = v.match(/^Q([1-4])(20\d{2})$/);
  if (m) return `${m[1]}Q${m[2]}`;
 
  return v;
};
const isQuarterToken = (v) => /^[1-4]Q20\d{2}$/.test(v);
const validateForm = (beginVal, endVal) => {
  let errors = [];

  const b = (beginVal || '').trim().toUpperCase();
  const e = (endVal || '').trim().toUpperCase();

  const bNorm = normalizeQuarterPattern(b);
  const eNorm = normalizeQuarterPattern(e);

  const isValidDate = (val) =>
    /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/.test(val);

  const isValidQuarter = (val) =>
    /^[1-4]Q20\d{2}$/.test(val);

  // 🔴 BEGIN validation
  if (b) {
    if (!isValidDate(b) && !isValidQuarter(bNorm)) {
      errors.push({
        field: 'fromDate',
        errorType: 'invalidFormat',
        message: VALIDATE_QUARTER_VALUE, // ✅ OLD message reused
      });
    }
  }

  // 🔴 END validation
  if (e) {
    if (!isValidDate(e) && !isValidQuarter(eNorm)) {
      errors.push({
        field: 'toDate',
        errorType: 'invalidFormat',
        message: VALIDATE_QUARTER_VALUE, // ✅ OLD message reused
      });
    }
  }

  // 🔴 RANGE validation
  if (errors.length === 0 && b && e) {
    const cmpBegin = isValidQuarter(bNorm)
      ? fromQtrToDT(bNorm)
      : b;

    const cmpEnd = isValidQuarter(eNorm)
      ? toQtrToDT(eNorm)
      : e;

    if (compareDate(cmpBegin, cmpEnd)) {
      errors.push({
        field: 'fromDate>toDate',
        message:
          constantMessageData.END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
      });
    }
  }

  return errors;
};
 
const handleOnblurEvent = (type, value) => {
  let formattedValue = normalizeQuarterPattern(value || '');
  formattedValue = autoFormateDate(formattedValue).toUpperCase();

  let nextBegin = begin;
  let nextEnd = end;

  if (type === 'fromDate') {
    nextBegin = formattedValue;
    setBegin(nextBegin);
  }

  if (type === 'end') {
    nextEnd = formattedValue;
    setEnd(nextEnd);
  }

  if (!nextBegin && !nextEnd) return;

  const errors = validateForm(nextBegin, nextEnd);

  dispatch(dispatchErrorMsgPreInvoice(errors));
};
  // Rebate programe error on plan type change
  React.useEffect(() => {
    handleOnblurEvent('rebateProgramCd', '1');
  }, [state.planTypeCd]);
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/PreInvoiceUnitAdjustment', true);
    } else {
      tabHighLigther('/PreInvoiceUnitAdjustment', false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // Search button on click functionality
  // const onClickOnSearch = () => {
  //   const rebateProgramName = rebateProgramList.find(
  //     (item) => item.id == state.rebateProgramCd
  //   );
  //   let localErr = getErrorMsg || [];
  //   if (selectedOption == 'Adjustment_Date_Range' && !begin) {
  //     localErr =
  //       localErr && localErr?.filter((item) => item.field !== 'fromDate');
  //     localErr.push({
  //       field: 'fromDate',
  //       errorType: 'beginQtrRequired',
  //       message: constantMessageData.BEGIN_QUATER_REQ,
  //     });
  //   }
  //   if (selectedOption == 'Invoice_Quarter' && !startQtr) {
  //     localErr =
  //       localErr && localErr?.filter((item) => item.field !== 'startQtr');
  //     localErr.push({
  //       field: 'startQtr',
  //       errorType: 'startQtrRequired',
  //       message: START_QUATER_REQ,
  //     });
  //   }
  //   if (state.rebateProgramCd === '-1') {
  //     localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
  //     localErr.push({
  //       field: 'rebateProgramCd',
  //       errorType: 'rebateRequired',
  //       message: REBATE_PROGRAM_REQUIRED,
  //     });
  //   }
  //   const unique = [...new Set(localErr)];
  //   dispatch(dispatchErrorMsgPreInvoice(unique));
  //   if (state.rebateProgramCd != '-1' && unique?.length === 0) {
  //     setSearchClicked(true);
  //     dispatch(dispatchRebateProgramName(rebateProgramName));
  //     dispatch(dispatchQtrRange(startQtr));
  //     dispatch(getSelectedOption(selectedOption));
  //     dispatch(getSelectedReportOption(selectedReport));
  //     dispatch(dispatchDateRange({ begin, end }));
  //     dispatch(
  //       dispatchDisplayObjInvoice({
  //         rebateProgramName,
  //         quarterFrom: startQtr,
  //         selectedOption,
  //         selectedReportOption: selectedReport,
  //         begin,
  //         end,
  //       })
  //     );

  //     if (selectedReport === 'Detail') {
  //       dispatch(dispatchPreInvoiceSummary([]));
  //       dispatch(dispatchPreInvoiceDetail([]));
  //       dispatch(
  //         getPreInvoiceDetail({
  //           rebateProgramCd: state.rebateProgramCd,
  //           beginDate: begin || null,
  //           endDate: end || null,
  //           allDate: selectedOption == 'Adjustment_Date_Range' ? 0 : 1,
  //           qtr: startQtr || null,
  //           allqtr: selectedOption == 'Invoice_Quarter' ? 0 : 1,
  //         })
  //       );
  //     }

  //     if (selectedReport === 'Summary') {
  //       dispatch(dispatchPreInvoiceSummary([]));
  //       dispatch(dispatchPreInvoiceDetail([]));
  //       dispatch(
  //         getPreInvoiceSummary({
  //           rebateProgramCd: state.rebateProgramCd,
  //           beginDate: begin || null,
  //           endDate: end || null,
  //           allDate: selectedOption == 'Adjustment_Date_Range' ? 0 : 1,
  //           qtr: startQtr || null,
  //           allqtr: selectedOption == 'Invoice_Quarter' ? 0 : 1,
  //         })
  //       );
  //     }
  //   }
  //   // }
  // };
  const onClickOnSearch = () => {
  const rebateProgramName = rebateProgramList.find(
    (item) => item.id == state.rebateProgramCd
  );
  let localErr = getErrorMsg || [];
 
  if (selectedOption == 'Adjustment_Date_Range' && !begin) {
    localErr = localErr && localErr?.filter((item) => item.field !== 'fromDate');
    localErr.push({
      field: 'fromDate',
      errorType: 'beginQtrRequired',
      message: constantMessageData.BEGIN_QUATER_REQ,
    });
  }
  if (selectedOption == 'Invoice_Quarter' && !startQtr) {
    localErr = localErr && localErr?.filter((item) => item.field !== 'startQtr');
    localErr.push({
      field: 'startQtr',
      errorType: 'startQtrRequired',
      message: START_QUATER_REQ,
    });
  }
  if (state.rebateProgramCd === '-1') {
    localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    localErr.push({
      field: 'rebateProgramCd',
      errorType: 'rebateRequired',
      message: REBATE_PROGRAM_REQUIRED,
    });
  }
  const unique = [...new Set(localErr)];
  dispatch(dispatchErrorMsgPreInvoice(unique));
 
  if (state.rebateProgramCd != '-1' && unique?.length === 0) {
    setSearchClicked(true);
    dispatch(dispatchRebateProgramName(rebateProgramName));
    dispatch(dispatchQtrRange(startQtr));
    dispatch(getSelectedOption(selectedOption));
    dispatch(getSelectedReportOption(selectedReport));
    dispatch(dispatchDateRange({ begin, end }));
    dispatch(
      dispatchDisplayObjInvoice({
        rebateProgramName,
        quarterFrom: startQtr,
        selectedOption,
        selectedReportOption: selectedReport,
        begin,
        end,
      })
    );
 
    
    const rawBegin = begin;
    const rawEnd = end || begin;
    const bNorm = normalizeQuarterPattern(rawBegin);
    const eNorm = normalizeQuarterPattern(rawEnd);
 
    const effectiveBegin =
      selectedOption === 'Adjustment_Date_Range'
        ? (isQuarterToken(/^[1-4]Q\d{2}$/.test(bNorm) ? autoFormateDate(bNorm) : bNorm)
            ? fromQtrToDT(/^[1-4]Q\d{2}$/.test(bNorm) ? autoFormateDate(bNorm) : bNorm)
            : rawBegin)
        : rawBegin;
 
    const effectiveEnd =
      selectedOption === 'Adjustment_Date_Range'
        ? (isQuarterToken(/^[1-4]Q\d{2}$/.test(eNorm) ? autoFormateDate(eNorm) : eNorm)
            ? toQtrToDT(/^[1-4]Q\d{2}$/.test(eNorm) ? autoFormateDate(eNorm) : eNorm)
            : rawEnd)
        : rawEnd;
 
    if (selectedReport === 'Detail') {
      dispatch(dispatchPreInvoiceSummary([]));
      dispatch(dispatchPreInvoiceDetail([]));
      dispatch(
        getPreInvoiceDetail({
          rebateProgramCd: state.rebateProgramCd,
          beginDate: effectiveBegin || null,
          endDate: effectiveEnd || null,
          allDate: selectedOption == 'Adjustment_Date_Range' ? 0 : 1,
          qtr: startQtr || null,
          allqtr: selectedOption == 'Invoice_Quarter' ? 0 : 1,
        })
      );
    }
 
    if (selectedReport === 'Summary') {
      dispatch(dispatchPreInvoiceSummary([]));
      dispatch(dispatchPreInvoiceDetail([]));
      dispatch(
        getPreInvoiceSummary({
          rebateProgramCd: state.rebateProgramCd,
          beginDate: effectiveBegin || null,
          endDate: effectiveEnd || null,
          allDate: selectedOption == 'Adjustment_Date_Range' ? 0 : 1,
          qtr: startQtr || null,
          allqtr: selectedOption == 'Invoice_Quarter' ? 0 : 1,
        })
      );
    }
  }
};

  if (
    isSearchClicked &&
    (getPreInvoiceDetailList?.preInvoiceUnitAdjustmentDetailsVO?.length > 0 ||
      getPreInvoiceSum?.preInvoiceUnitAdjustmentsVO?.length > 0)
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/DisplayPreInvoiceUnitAdjustment',
      value: 'Display PreInvoice Unit Adjustment',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props?.history) {
      props.history.push({
        pathname: '/DisplayPreInvoiceUnitAdjustment',
      });
    }
    dispatch(clearReduxForFilterAndSort('/DisplayPreInvoiceUnitAdjustment'));
  }

  // setting Quarter From
  const handlefromChange = (event) => {
    let { value } = event.target;
    if (value?.includes('q')) {
      value = value?.replace('q', 'Q');
    }
    setStartQtr(value);
  };

  const handleChange = (event) => {
    if (event.target.value === 'Adjustment_Date_Range') {
      setStartQtr('');
    } else {
      setBegin('');
      setEnd('');
    }
    setSelectedOption(event.target.value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'startQtr');
    localErr = localErr.filter((item) => item.field !== 'fromDate');
    localErr = localErr.filter((item) => item.field !== 'toDate');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPreInvoice(unique));
  };

  const handleBeginChange = (e) => {
    const value = e.target.value.toUpperCase();
    setBegin(value.toUpperCase());
    // if (endDateValue === '') {
    //   setEnd(value.toUpperCase());
    // }
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'fromDate');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPreInvoice(unique));
    // setBegin(event.target.value);
  };
  const handleToChange = (e) => {
    const value = e.target.value.toUpperCase();
    setEnd(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'toDate');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgPreInvoice(unique));
  };

  const errorMessageList = getErrorMsg?.map((item) => {
    if (item.field == 'fromDate') {
      return {
        ...item,
        message: item.message
          ?.replace('date range', 'Begin Date')
          ?.replace('As Of Date', 'Begin Date'),
      };
    }
    if (item.field == 'toDate') {
      return {
        ...item,
        message: item.message?.replace('date range', 'End Date'),
      };
    }
    return item;
  });

  return (
    <div
      className="tabs-container tBillPanel custom-check"
      data-testid="program-and-eligibility"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="PreInvoice Unit Adjustment"
      />
      {errorMessageList?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            errorMessageList?.length > 0
              ? [...new Set(_.map(errorMessageList, (l) => l.message))]
              : []
          }
        />
      ) : null}

      <div className="row">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            data-testid="radio-button-for-rcdd"
            id="radio-button-for-rcdd_id"
            labelName="Plan Type"
            required
            optionList={radioList || []}
            defaultValue={state && state.planTypeCd}
            filterAction={(e) => {
              handleOnChangeEvent(e, 'planTypeCd');
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-4 frr-two-col-radio ">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Rebate Program<span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-3">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  name="rebateProgram"
                  id="rebate_program"
                  label="Rebate Program"
                  fullWidth
                  select
                  required
                  inputProps={{ maxLength: 11, id: 'rebate_program' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd'
                            ? 'mandate-fields'
                            : null
                        )
                      : null
                  }
                  onBlur={(e) =>
                    handleOnblurEvent('rebateProgramCd', e.target.value)
                  }
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                  }
                  value={
                    state && state.rebateProgramCd ? state.rebateProgramCd : ''
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    key=""
                    value="-1"
                    className="frr-dropdown-blank-item"
                  />
                  {rebateProgramList &&
                  rebateProgramList.length &&
                  rebateProgramList.length > 0
                    ? rebateProgramList.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id} className="frr-logcheck-dropdown-item">
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-md-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Report Type</legend>
            <div className="form-wrapper p-3">
              <div className="mui-custom-form input-md field-xl">
                <div className="sub-radio no-margin">
                  <FormControl>
                    <RadioGroup row name="Report Type" value={selectedReport}>
                      <FormControlLabel
                        value="Detail"
                        control={<Radio />}
                        label="Detail"
                        name="Detail"
                        onChange={(e) => setSelectedReport(e.target.value)}
                      />
                      <FormControlLabel
                        value="Summary"
                        control={<Radio />}
                        label="Summary"
                        onChange={(e) => setSelectedReport(e.target.value)}
                        name="Summary"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-sm-12">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">Time Period</legend>
            <div className="form-wrapper p-0 mt-2">
              <div className="mui-custom-form input-md field-xl">
                <div className="sub-radio no-margin">
                  <RadioGroup
                    row
                    name="time-period"
                    value={selectedOption}
                    onChange={handleChange}
                  >
                    <div className="col-sm-4">
                      <FormControlLabel
                        value="Adjustment_Date_Range"
                        control={<Radio />}
                        label="Adjustment Date/Quarter Range"
                        data-test="Adjustment Date Range"
                      />
                      <Grid container spacing={2}>
                        <Grid item xs={6} className="mandate-fields">
                          <TextField
                            label="Begin"
                            id="Begin"
                            placeholder=""
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                            value={begin}
                            onChange={handleBeginChange}
                            onBlur={(e) =>
                              handleOnblurEvent('fromDate', e.target.value)
                            }
                            disabled={
                              selectedOption !== 'Adjustment_Date_Range'
                            }
                            inputProps={{ maxLength: 10 }}
                            name="Begin"
                            helperText={
                              errorMessageList?.length > 0
                                ? [
                                    ...new Set(
                                      errorMessageList
                                        ?.filter((x) => {
                                          return x.field === 'fromDate';
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              getErrorMsg?.length > 0 &&
                              getErrorMsg?.filter((x) => {
                                return x.field === 'fromDate';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      getErrorMsg
                                        ?.filter((x) => {
                                          return x.field === 'fromDate';
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </Grid>
                        <Grid item xs={6} className="mandate-fields">
                          <TextField
                            label="End"
                            id="End"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 10 }}
                            name="end"
                            value={end}
                            onChange={handleToChange}
                            onBlur={(e) =>
                              handleOnblurEvent('end', e.target.value)
                            }
                            disabled={
                              selectedOption !== 'Adjustment_Date_Range'
                            }
                            helperText={
                              getErrorMsg?.length > 0
                                ? [
                                    ...new Set(
                                      getErrorMsg
                                        ?.filter((x) => {
                                          return x.field === 'toDate';
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : null
                            }
                            error={
                              getErrorMsg?.length > 0 &&
                              getErrorMsg?.filter((x) => {
                                return x.field === 'toDate';
                              }).length > 0
                                ? [
                                    ...new Set(
                                      getErrorMsg
                                        ?.filter((x) => {
                                          return x.field === 'toDate';
                                        })
                                        .map((item) => {
                                          return item.message;
                                        })
                                    ),
                                  ]
                                : false
                            }
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <div className="col-sm-4">
                      <FormControlLabel
                        value="Invoice_Quarter"
                        control={<Radio />}
                        label="Invoice Quarter"
                        data-test="Invoice_Quarter"
                      />
                      <div className="row ">
                        <div className="col-6 ">
                          {/* <div className='mui-custom-textField input-md w-100'style={{ marginTop: '20px' }}> */}
                          <Grid item xs={12}>
                            <TextField
                              size="small"
                              label="Invoice Quarter"
                              id="Invoice Quarter"
                              placeholder=""
                              required
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled={selectedOption !== 'Invoice_Quarter'}
                              value={startQtr}
                              className="mandate-fields frr-display-hidden-label"
                              onChange={handlefromChange}
                              onBlur={(e) =>
                                handleOnblurEvent('startQtr', e.target.value)
                              }
                              inputProps={{ maxLength: 10 }}
                              name="start"
                              helperText={
                                getErrorMsg?.length > 0
                                  ? [
                                      ...new Set(
                                        getErrorMsg
                                          ?.filter((x) => {
                                            return x.field === 'startQtr';
                                          })
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : null
                              }
                              error={
                                getErrorMsg?.length > 0 &&
                                getErrorMsg?.filter((x) => {
                                  return x.field === 'startQtr';
                                }).length > 0
                                  ? [
                                      ...new Set(
                                        getErrorMsg
                                          ?.filter((x) => {
                                            return x.field === 'startQtr';
                                          })
                                          .map((item) => {
                                            return item.message;
                                          })
                                      ),
                                    ]
                                  : false
                              }
                            />
                          </Grid>
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </RadioGroup>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div className="col-12 btn-wrapper mb-2">
        <div className="float-right mt-2 hide-on-print">
          <Button
            className="btn btn-success btn-search"
            data-testid="view_detail_ia"
            type="button"
            onClick={onClickOnSearch}
          >
            {' '}
            <SVGComponent iconName="Icon-search" /> {'  '} Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PreInvoice;
